'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (SubscriptionPage, $) {

		var SubscriptionPageInit = function SubscriptionPageInit(current) {
			var accountLink = '<a href="/account" class="account-link"><svg viewBox="0 0 15 27" fill="#777770" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon-arrow-left-reviews"><path d="M12.0018397,13.2302866 L0.84526814,2.08500706 C0.366674393,1.60689772 0.366674393,0.836481724 0.84526814,0.358372383 C1.32358211,-0.119457461 2.09390539,-0.119457461 2.57221936,0.358372383 L14.5956536,12.3696372 C15.0708721,12.8443747 15.0680492,13.6227191 14.5903122,14.0909359 L2.57348823,26.0954714 C2.34378713,26.3337657 2.02915963,26.4619071 1.70607306,26.4619071 C1.38832273,26.4619071 1.07532417,26.3320239 0.84526814,26.1022007 C0.366674393,25.6240914 0.366674393,24.8536754 0.84526814,24.3755661 L12.0018397,13.2302866 Z"></path></g></svg>Back to Account</a>';
			$('#customer_tab_nav').prepend(accountLink);
		};

		SubscriptionPage.init = function () {
			$(window).on('load', function () {
				SubscriptionPageInit();
			});
		};
	})(window.SubscriptionPage = window.SubscriptionPage || {}, _jquery2.default, undefined);
};